import { api_url } from "../../utils/constants";
const axios = require('axios').default;

// Per-locality aircon job statistics for the locality pages. Aggregates only -
// job counts arrive as floored bands and shares rounded to 5%. Called from
// getStaticProps, so callers must handle rejection and fall back to the
// committed snapshot in data/aircon-locality-stats.
export const getAirconLocalityStats = (countryName) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/public/GetAirconLocalityStats",
          params : {"countryName": countryName},
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error);
                reject(error);
            }
        )
    });
}

export const calculateAirconServiceCost = (userId, requestCriteria, serviceDate, startTime, endTime) => {
    return axios.post(api_url + "/public/CalculateAirconServiceCost", {
        userId,
        requestCriteria,
        serviceDate,
        startTime,
        endTime
    }, {
        headers: { "Content-Type": "application/json" }
    })
    .then(response => response.data)
    .catch(error => {
        console.error("Error calculating aircon service cost:", error);
        throw error;
    });
};

export const getAirconServiceCost = (
    userId,
    serviceType,
    unitCount,
    serviceSubType,
    requestIdInt,
    serviceDate,
    mountType,
    startTime, 
    endTime,
    frequency,
    annualServiceCount
) => {
    return new Promise((resolve, reject) => {
        const params = {
            userId: userId ? userId : "",
            serviceType,
            unitCount,
            serviceSubType,
            requestIdInt,
            serviceDate,
            mountType: mountType ? mountType : "",
            startTime, 
            endTime,
            frequency: frequency ?? "Only once",
            annualServiceCount: annualServiceCount ?? "1",
        };

        axios({
            method: "GET",
            url: api_url + "/public/GetAirconServiceCost",
            params, // Axios automatically converts this to query string
            headers: {
                "Content-Type": "application/json", // optional, safe default
            },
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            console.error(error);
            reject(error);
        });
    });
};

export const getNewUserDiscountPercent = (userId, cost) => {
    return new Promise((resolve, reject) => {
        axios({
          method : "GET",
          url :  api_url + "/public/GetNewUserDiscountPercent",
          params : {'userId': userId ? userId : "", 'cost': cost},
          headers:  { "Content-Type": "multipart/form-data"},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

